import React from 'react'
import ModalContent from '../../../components/modals/modal_content'
import FlatButton from '../../../components/buttons/flat_button'
import { PdfOrientation } from '../hooks/use_business_pdf_download'

interface PdfOrientationModalProps {
  isOpen: boolean
  onClose: () => void
  onSelectOrientation: (orientation: PdfOrientation) => void
}

export const PdfOrientationModal: React.FC<PdfOrientationModalProps> = ({
  isOpen,
  onClose,
  onSelectOrientation,
}) => {
  if (!isOpen) return null

  const handleSelect = (orientation: PdfOrientation) => {
    onSelectOrientation(orientation)
    onClose()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <ModalContent title="PDFの向きを選択" onClose={onClose}>
        <div className="p-8">
          <p className="text-base mb-6 text-center">
            ダウンロードするPDFの向きを選択してください
          </p>
          <div className="flex gap-6 justify-center mb-4">
            {/* 縦型 */}
            <button
              onClick={() => handleSelect('portrait' as PdfOrientation)}
              className="flex flex-col items-center p-6 border-2 border-main-gray rounded-lg hover:border-main-green hover:bg-gray-50 transition-colors"
            >
              <div className="mb-4">
                <svg
                  width="80"
                  height="100"
                  viewBox="0 0 80 100"
                  className="border-2 border-main-green"
                >
                  <rect width="80" height="100" fill="white" />
                  <rect x="5" y="5" width="70" height="10" fill="#e5e7eb" />
                  <rect x="5" y="20" width="70" height="75" fill="#f3f4f6" />
                </svg>
              </div>
              <span className="text-lg font-bold">縦型</span>
              <span className="text-sm text-gray-600 mt-1">(A4 縦向き)</span>
            </button>

            {/* 横型 */}
            <button
              onClick={() => handleSelect('landscape' as PdfOrientation)}
              className="flex flex-col items-center p-6 border-2 border-main-gray rounded-lg hover:border-main-green hover:bg-gray-50 transition-colors"
            >
              <div className="mb-4">
                <svg
                  width="100"
                  height="80"
                  viewBox="0 0 100 80"
                  className="border-2 border-main-green"
                >
                  <rect width="100" height="80" fill="white" />
                  <rect x="5" y="5" width="90" height="10" fill="#e5e7eb" />
                  <rect x="5" y="20" width="90" height="55" fill="#f3f4f6" />
                </svg>
              </div>
              <span className="text-lg font-bold">横型</span>
              <span className="text-sm text-gray-600 mt-1">(A4 横向き)</span>
            </button>
          </div>
          <p className="text-sm mb-6">
            ※横向きを選択した場合、縦長のページは自動的に縮小されて印刷されます。
          </p>
          <div className="mt-8 flex justify-center">
            <FlatButton onClick={onClose} outline>
              キャンセル
            </FlatButton>
          </div>
        </div>
      </ModalContent>
    </div>
  )
}
